<!-- 院长端 -->
<template>
  <div class="data-view" ref="view">
    <div class="page-title">
      <div class="text">
        <div v-if="!isShowSeach">
          <span>关于“{{ seachText }}”共搜索到</span>
          <span class="text-totle">{{ total }}</span>
          <span>条结果</span>
        </div>
        <div v-if="!isShowSeach" class="text-back" @click="back">返回</div>
        <div style="width:240px;margin:0 10px">
          <a-range-picker
            :disabledDate="disabledDate"
            :value="seachPicker"
            @change="onChangeRangeDate"
          >
            <template #suffixIcon>
              <a-icon style="color:#1890ff;" type="calendar" />
            </template>
          </a-range-picker>
        </div>
        <div style="width:160px;" v-if="isShowSeach">
          <el-input
            size="mini"
            placeholder="请输入位置关键字"
            v-model="seachText"
            @keyup.enter.native="seach(1)"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="seach(1)"
            ></i>
          </el-input>
        </div>
      </div>
      <div class="top-btn">
        <el-button size="small" @click="toExportExcele">导出</el-button>
        <el-button size="small" v-print="printObj">打印</el-button>
      </div>
    </div>
    <div class="page-con" v-if="isNoData">
      <div class="con-title">
        <div
          class="bed-name"
          :class="{ 'bed-name-active': isActive == index }"
          v-for="(item, index) in tableData"
          :key="index"
          :style="{ 'z-index': index, top: index * 70 + 'px' }"
          @click="changeBedName(index)"
        >
          {{ item.bedName }}
        </div>
      </div>
      <div class="con-table">
        <div class="row">
          <div
            class="row-item"
            v-for="(row, index) in tableData[isActive].headerList"
            :key="index"
            :style="{ color: row.markedRed ? '#FF4D4F' : '' }"
          >
            {{ row.columnZh }}
          </div>
        </div>
        <div
          class="row-con"
          v-for="(row, index) in tableData[isActive].dataList"
          :key="index"
        >
          <div
            class="row-con-item"
            v-for="(item, index2) in row"
            :key="index2"
            v-html="item.dataName"
            :style="{ color: item.markedRed ? '#FF4D4F' : '' }"
          ></div>
        </div>
      </div>
    </div>
    <NoData v-if="!isNoData" />
    <div class="pagination" v-if="pages > 1 && isNoData">
      <a-pagination
        :current="current"
        :total="total"
        :defaultPageSize="pageSize"
        show-less-items
        @change="showSizeChange"
      />
    </div>
    <div class="con-table" id="printMe">
      <div
        style="page-break-after: always; padding-top:10px;"
        v-for="(item, index) in pointData"
        :key="index"
      >
        <div
          style="page-break-after: always; padding-top:10px;"
          v-for="(ktem, titlekndex) in item.headerList"
          :key="titlekndex"
        >
          <div class="row">
            <div
              class="row-item"
              v-for="(jtem, jndex) in ktem"
              :key="jndex"
              :style="{ color: jtem.markedRed ? '#FF4D4F' : '' }"
            >
              {{ jtem.columnZh }}
            </div>
          </div>
          <div
            class="row-con"
            v-for="(jtem, jndex) in item.dataList"
            :key="jndex"
          >
            <div
              class="row-con-item"
              v-for="(dataListktem, kndex) in jtem[titlekndex]"
              :key="kndex"
              :style="{ color: dataListktem.markedRed ? '#FF4D4F' : '' }"
              v-html="dataListktem.dataName"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from './noData.vue';
export default {
  components: { NoData },
  data() {
    return {
      printObj: {
        id: 'printMe',
        popTitle: '清雷科技',
      },
      isNoData: false,
      current: 1,
      pages: 2,
      total: 1,
      pageSize: 20,
      preDate: '',
      isShowSeach: true,
      pointData: [
        {
          bedId: 0,
          bedName: '',
          dataList: [
            {
              dataName: {},
              dataType: '',
              dataVal: {},
              markedRed: true,
            },
          ],
          headerList: [
            {
              columnEn: '',
              columnZh: '',
              markedRed: true,
            },
          ],
        },
      ],
      seachPicker: [],
      totle: 0,
      seachText: '',
      isActive: 0,
      tableData: [
        {
          bedId: 0,
          bedName: '',
          dataList: [
            {
              dataName: {},
              dataType: '',
              dataVal: {},
              markedRed: true,
            },
          ],
          headerList: [
            {
              columnEn: '',
              columnZh: '',
              markedRed: true,
            },
          ],
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.$refs.view.style.minWidth = window.innerWidth + 'px';

    let date = new Date();
    let endMonth =
      date.getMonth() + 1 >= 10
        ? date.getMonth() + 1
        : '0' + (date.getMonth() + 1);
    let endDay = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
    let dataStrEnd = date.getFullYear() + '-' + endMonth + '-' + endDay;
    let dataStrStart = this.getPreMonth(dataStrEnd);

    this.seachPicker.push(...[dataStrStart, dataStrEnd]);
    this.getTableData();
    this.getTableData(1, 20000);
  },
  methods: {
    showSizeChange(data) {
      console.log(data);
      this.current = data;
      this.getTableData(this.current, this.pageSize);
    },
    getTableData(pageNum = 1, pageSize = 20) {
      console.log(11111111);
      let param2 = {
        startDate: this.seachPicker[0],
        endDate: this.seachPicker[1],
        searchKeyWord: this.seachText,
        pageSize: pageSize,
        pageNum: pageNum,
      };
      this.total = '...';
      this.$get(
        '/api/v3/accreportdata/queryAccReportDataPage',
        param2,
        (res) => {
          if (res.code == 0) {
            if (pageSize >= 20000) {
              this.pointData = JSON.parse(
                JSON.stringify(res.data.accReportDataVoPage.records)
              );
              this.changeDataPlan(this.pointData, true);
            } else {
              this.tableData = res.data.accReportDataVoPage.records;
              this.current = res.data.accReportDataVoPage.current;
              this.pages = res.data.accReportDataVoPage.pages;
              this.total = res.data.accReportDataVoPage.total;
              this.pageSize = res.data.accReportDataVoPage.size;
              this.changeDataPlan(this.tableData, false);
              if (this.tableData.length > 0) {
                this.isNoData = true;
              } else {
                this.isNoData = false;
              }
            }
            if (!this.isShowSeach) {
              this.changeDataPlan(this.tableData, true);
            }
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          this.$message.error('服务端发生异常');
        }
      );
    },
    getPreMonth(date) {
      var arr = date.split('-');
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中月的天数
      var year2 = year;
      var month2 = parseInt(month) - 1;
      if (month2 == 0) {
        year2 = parseInt(year2) - 1;
        month2 = 12;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = days2;
      }
      if (month2 < 10) {
        month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2;
      return t2;
    },
    disabledDate(date) {
      let today = new Date(); //当天
      today.setFullYear(today.getFullYear() - 1);
      return (
        date > this.$moment(this.$moment(new Date()).format('YYYY-MM-DD')) ||
        date < this.$moment(this.$moment(today).format('YYYY-MM-DD'))
      );
    },
    seach(data = 2) {
      console.log(111);
      if (data == 1) {
        if (this.seachText == '') {
          return;
        } else {
          this.isShowSeach = false;
          this.getTableData();
        }
      } else {
        if ((data = 3)) {
          if (this.isShowSeach == true) {
            this.isShowSeach = true;
          }
          this.getTableData();
          this.getTableData(1, 20000);
        } else {
          this.isShowSeach = false;
          this.getTableData();
        }
      }
    },
    back() {
      this.isShowSeach = true;
      this.seachText = '';
      this.seachPicker = [];
      let date = new Date();
      let endMonth =
        date.getMonth() + 1 >= 10
          ? date.getMonth() + 1
          : '0' + (date.getMonth() + 1);

      let endDay = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
      let dataStrEnd = date.getFullYear() + '-' + endMonth + '-' + endDay;
      let dataStrStart = this.getPreMonth(dataStrEnd);
      this.seachPicker.push(...[dataStrStart, dataStrEnd]);
      this.getTableData();
      this.getTableData(1, 20000);
    },
    onChangeRangeDate(value, dateString) {
      console.log(dateString);
      this.seachPicker = dateString;
      this.seach(3);
    },
    changeBedName(data) {
      this.isActive = data;
    },
    changeDataPlan(data, flag) {
      data.forEach((item) => {
        item.dataList.forEach((jtem) => {
          jtem[0].dataName = jtem[0].dataName.replace(/\(/g, '<br /\>(');
        });
      });
      if (flag) {
        this.pointData = JSON.parse(JSON.stringify(data));
        this.changeTableData(this.pointData);
      }
    },
    // 导出表格
    toExportExcele(event) {
      let target = event.target;
      if (target.nodeName == 'SPAN') {
        target = event.target.parentNode;
      }
      target.blur();
      let param2 = {
        startDate: this.seachPicker[0],
        endDate: this.seachPicker[1],
        searchKeyWord: this.seachText,
      };
      this.$get(
        '/api/v3/accreportdata/exportAccReportDataList',
        param2,
        (res) => {
          if (res.code == 0) {
            var a = document.createElement('a'); //创建一个<a></a>标签
            a.href = `/api/v3/accreportdata/downloadFile?filePath=${res.data}`; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
            a.style.display = 'none'; // 障眼法藏起来a标签
            document.body.appendChild(a); // 将a标签追加到文档对象中
            a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
            a.remove(); // 一次性的，用完就删除a标签
            // window.location.href = `${location.origin}/api/api/v3/accreportdata/downloadFile?filePaht=${res.data}`;
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          this.$message.error('服务端发生异常');
        }
      );
    },
    // 打印statr
    // 表头一维数组转二维数组
    changeTitleData(data) {
      var newData = [];
      var zyf = 6; //一维数组转二维数组长度(此处是二维数组每一个长度控制)
      for (var i = 0; i < Math.ceil(data.length / zyf); i++) {
        newData[i] = [];
        newData[i].push(data[i * zyf]);
        for (var j = 1; j < zyf; j++) {
          if (data[i * zyf + j] == undefined) {
            //超出长度控住
            return newData;
          } else {
            newData[i].push(data[i * zyf + j]);
          }
        }
      }
      return newData;
    },
    // 表格数据一维数组转二维数组
    changeDataList(data) {
      var newData = [];
      var zyf = 6; //一维数组转二维数组长度(此处是二维数组每一个长度控制)
      for (var i = 0; i < Math.ceil(data.length / zyf); i++) {
        newData[i] = [];
        newData[i].push(data[i * zyf]);
        for (var j = 1; j < zyf; j++) {
          if (data[i * zyf + j] == undefined) {
            //超出长度控住
            return newData;
          } else {
            newData[i].push(data[i * zyf + j]);
          }
        }
      }
      return newData;
    },
    // 更改打印数据格式入口方法
    changeTableData(tableData) {
      // 表头数据
      for (let i = 0; i < tableData.length; i++) {
        let allHasData = tableData[i].headerList.splice(0, 4);
        console.log(allHasData, 'allHasDataallHasDataallHasData');
        let newHeaderList = this.changeTitleData(tableData[i].headerList);
        // newHeaderList.forEach((item) => {
        //   item.splice(0, 0, ...allHasData);
        // });

        for (let k = 0; k < newHeaderList.length; k++) {
          newHeaderList[k].unshift(...allHasData);
        }
        //表格数据;
        let newDataList = [];
        for (let j = 0; j < tableData[i].dataList.length; j++) {
          let allHasDataCon = tableData[i].dataList[j].splice(0, 4);

          let resData = this.changeDataList(tableData[i].dataList[j]);
          resData.forEach((item) => {
            item.splice(0, 0, ...allHasDataCon);
          });
          newDataList.push(resData);
        }
        console.log(newHeaderList, newDataList);
        this.pointData[i].headerList = newHeaderList;
        this.pointData[i].dataList = newDataList;
      }
    },
  },
  beforeDestroy() {},
};
</script>
<style scoped lang="scss" media="print">
@page {
  size: auto;
  margin: 3mm;
}
.con-table {
  padding: 10px 10px 0;
  .row {
    display: flex;
    background: #f0f0f0;
    align-items: center;
    height: 48px;
    .row-item {
      width: 150px;
      text-align: center;
      white-space: nowrap;
    }
  }
  .row-con {
    display: flex;
    background: #fff;
    align-items: center;
    height: 48px;
    .row-con-item {
      width: 150px;
      height: 100%;
      text-align: center;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #e8e8e8;
      border-left: 1px solid #e8e8e8;
    }
    .row-con-item:last-child {
      border-right: 1px solid #e8e8e8;
    }
  }
  .row-con:last-child {
    .row-con-item {
      border-bottom: 1px solid #e8e8e8;
    }
  }
  .row-con:nth-child(odd) {
    background: #fafafa;
  }
}
</style>
<style lang="scss" scoped>
// 打印媒体查询

.data-view {
  background: #fff;
  height: 100%;
  .page-title {
    height: 56px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    box-shadow: 0px 1px 4px -2px rgba(0, 0, 0, 0.5);
    .text {
      position: fixed;
      top: 12px;
      left: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
      display: flex;
      align-items: center;
      .text-totle {
        color: #1890ff;
      }
      .text-back {
        color: #1890ff;
        cursor: pointer;
        margin: 10px;
      }
      ::v-deep .ant-input {
        height: 28px;
        background: #e6f7ff;
        color: #1890ff;
        border: none;
        height: 32px;
      }
      ::v-deep .ant-calendar-range-picker-separator {
        color: #1890ff;
      }
      ::v-deep .el-input--mini .el-input__inner {
        height: 32px;
        font-size: 14px;
        padding-left: 12px;
      }
    }
    .top-btn {
      position: fixed;
      top: 12px;
      right: 20px;
    }
  }
  .page-con {
    display: flex;
    align-content: center;
    justify-content: space-between;
    padding-bottom: 40px;
    background: #fff;
    .con-title {
      position: relative;
      .bed-name {
        width: 150px;
        height: 70px;
        cursor: pointer;
        font-size: 14px;
        background: #e6f7ff;
        color: #262626;
        text-align: center;
        display: flex;
        justify-content: center;
        padding-top: 5px;
        border-radius: 0px 8px 0px 0px;
        position: absolute;
      }
      .bed-name-active {
        color: #fff !important;
        background: #1890ff;
      }
      .bed-name:hover {
        color: #1890ff;
      }
    }
    .con-table {
      position: relative;
      top: 0;
      left: 0;
      flex: 1;
      margin: 10px 0 0 160px;
      .row {
        display: flex;
        background: #f0f0f0;
        align-items: center;
        height: 60px;
        .row-item {
          width: 120px;
          height: 60px;
          line-height: 60px;
          padding: 0 20px;
          text-align: center;
          white-space: nowrap;
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
      }
      .row-con {
        display: flex;
        background: #fff;
        align-items: center;
        height: 60px;
        .row-con-item {
          width: 120px;
          height: 100%;
          padding: 0 20px;
          text-align: center;
          white-space: nowrap;
          display: flex;
          align-items: center;
          justify-content: center;
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .row-con-item:last-child {
          border-right: 1px solid #e8e8e8;
        }
      }
      .row-con:hover {
        .row-con-item {
          background: #ecf5ff;
        }
      }
      .row-con:last-child {
        border-bottom: 1px solid #e8e8e8;
      }
      .row-con:nth-child(odd) {
        background: #fafafa;
      }
    }
  }
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 160px;
    height: 60px;
    background: #fff;
  }
  .con-table {
    position: fixed;
    top: 0;
    left: 99999999px;
    flex: 1;
    margin: 10px 0 0 160px;
    .row {
      display: flex;
      background: #f0f0f0;
      align-items: center;
      height: 60px;
      .row-item {
        width: 120px;
        padding: 0 20px;
        text-align: center;
        white-space: nowrap;
      }
    }
    .row-con {
      display: flex;
      background: #fff;
      align-items: center;
      height: 60px;
      .row-con-item {
        width: 120px;
        height: 100%;
        padding: 0 20px;
        text-align: center;
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 1px solid #e8e8e8;
        border-left: 1px solid #e8e8e8;
      }
      .row-con-item:last-child {
        border-right: 1px solid #e8e8e8;
      }
    }
    .row-con:last-child {
      .row-con-item {
        border-bottom: 1px solid #e8e8e8;
      }
    }
    .row-con:nth-child(odd) {
      background: #fafafa;
    }
  }
}
</style>
